// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Js_exn = require("rescript/lib/js/js_exn.js");
var ViewStack = require("../../../reason/common/ViewStack.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var ErrorComponent = require("../../../reason/common/Error/ErrorComponent.bs.js");
var Types__Attachment = require("../../../reason/common/types/Types__Attachment.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var UnselectedUnionMemberError = require("../../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
var ConversationMessageInputForm = require("../ConversationMessageInputForm.bs.js");
var UnsupportedAttachmentsDialog = require("../../../reason/common/Attachments/UnsupportedAttachmentsDialog.bs.js");
var Conversation__ConversationsSection__Common = require("./Conversation__ConversationsSection__Common.bs.js");
var Conversation__ConversationsSection__SendMessageButtons = require("./Conversation__ConversationsSection__SendMessageButtons.bs.js");
var Conversation__ConversationsSection__ConversationMessageArea = require("./Conversation__ConversationsSection__ConversationMessageArea.bs.js");
var ConversationConversationsSectionStartFirstConversation_context_graphql = require("../../../__generated__/ConversationConversationsSectionStartFirstConversation_context_graphql.bs.js");

var convertFragment = ConversationConversationsSectionStartFirstConversation_context_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationConversationsSectionStartFirstConversation_context_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationConversationsSectionStartFirstConversation_context_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationConversationsSectionStartFirstConversation_context_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationConversationsSectionStartFirstConversation_context_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function Conversation__ConversationsSection__StartFirstConversation(props) {
  var onConversationInitiated = props.onConversationInitiated;
  var onStartedInitiatingConversation = props.onStartedInitiatingConversation;
  var context = use(props.context);
  var connections = Core__Array.keepSome([props.connectionId]);
  var onConversationInitiated$1 = function (newConversationId) {
    if (onConversationInitiated !== undefined) {
      return onConversationInitiated(newConversationId);
    }
    
  };
  var onStartedInitiatingConversation$1 = function () {
    if (onStartedInitiatingConversation !== undefined) {
      return onStartedInitiatingConversation();
    }
    
  };
  var match = React.useState(function () {
        return [];
      });
  var setUnsupportedFiles = match[1];
  var messageConversationType = React.useRef("PRIVATE");
  var agentName;
  switch (context.__typename) {
    case "ForSalePropertyV5" :
        var match$1 = context.agentV2;
        agentName = match$1.__typename === "VisibleForSalePropertyAgent" ? match$1.agent.displayName : undefined;
        break;
    case "__unselected" :
        agentName = UnselectedUnionMemberError.raise("Can't get agent name for context of type " + context._0);
        break;
    default:
      agentName = context.agent.displayName;
  }
  var match$2 = Conversation__ConversationsSection__Common.InitiatePropertyConversationMutation.use();
  var initiatePropertyConversationMutate = match$2[0];
  var match$3 = Conversation__ConversationsSection__Common.InitiateMessageBroadcastConversationMutation.use();
  var initiateMessageBroadcastConversation = match$3[0];
  var match$4 = Conversation__ConversationsSection__Common.InitiateRentalNeedConversationMutation.use();
  var initiateRentalNeedConversationMutate = match$4[0];
  var match$5 = Conversation__ConversationsSection__Common.InitiateBuyerNeedConversationMutation.use();
  var initiateBuyerNeedConversationMutate = match$5[0];
  var mutate = function (state, reset, notifyOnFailure, notifyOnSuccess) {
    var match = Belt_Array.partition(state.attachments, (function (attachment) {
            return Types__Attachment.isImage(attachment);
          }));
    var files = match[1];
    var images = match[0];
    switch (context.__typename) {
      case "BuyerNeedV5" :
          onStartedInitiatingConversation$1();
          initiateBuyerNeedConversationMutate({
                connections: connections,
                input: {
                  buyerNeedId: context.id,
                  files: files.map(Conversation__ConversationsSection__Common.attachmentToInput),
                  images: images.map(Conversation__ConversationsSection__Common.attachmentToInput),
                  text: state.text
                }
              }, undefined, undefined, undefined, (function (response, errors) {
                  var match = response.initiateBuyerNeedConversation;
                  if (match === undefined) {
                    return notifyOnFailure();
                  }
                  if (match.__typename !== "BuyerNeedConversationInitiated") {
                    return notifyOnFailure();
                  }
                  var match$1 = match.conversation;
                  if (match$1 !== undefined) {
                    reset();
                    notifyOnSuccess(undefined);
                    return onConversationInitiated$1(match$1.id);
                  } else {
                    return notifyOnFailure();
                  }
                }), undefined, undefined);
          return ;
      case "MessageBroadcast" :
          onStartedInitiatingConversation$1();
          initiateMessageBroadcastConversation({
                connections: connections,
                input: {
                  files: files.map(Conversation__ConversationsSection__Common.attachmentToInput),
                  images: images.map(Conversation__ConversationsSection__Common.attachmentToInput),
                  messageId: context.id,
                  text: state.text,
                  visibility: messageConversationType.current
                }
              }, undefined, undefined, undefined, (function (response, errors) {
                  var match = response.initiateMessageBroadcastConversation;
                  if (match === undefined) {
                    return notifyOnFailure();
                  }
                  if (match.__typename !== "MessageBroadcastConversationInitiated") {
                    return notifyOnFailure();
                  }
                  var match$1 = match.conversation;
                  if (match$1 !== undefined) {
                    reset();
                    notifyOnSuccess(undefined);
                    return onConversationInitiated$1(match$1.id);
                  } else {
                    return notifyOnFailure();
                  }
                }), undefined, undefined);
          return ;
      case "RentalNeedV5" :
          onStartedInitiatingConversation$1();
          initiateRentalNeedConversationMutate({
                connections: connections,
                input: {
                  files: files.map(Conversation__ConversationsSection__Common.attachmentToInput),
                  images: images.map(Conversation__ConversationsSection__Common.attachmentToInput),
                  rentalNeedId: context.id,
                  text: state.text
                }
              }, undefined, undefined, undefined, (function (response, errors) {
                  var match = response.initiateRentalNeedConversation;
                  if (match === undefined) {
                    return notifyOnFailure();
                  }
                  if (match.__typename !== "RentalNeedConversationInitiated") {
                    return notifyOnFailure();
                  }
                  var match$1 = match.conversation;
                  if (match$1 !== undefined) {
                    reset();
                    notifyOnSuccess(undefined);
                    return onConversationInitiated$1(match$1.id);
                  } else {
                    return notifyOnFailure();
                  }
                }), undefined, undefined);
          return ;
      case "ForSalePropertyV5" :
      case "RentalPropertyV5" :
          break;
      case "__unselected" :
          return Js_exn.raiseError("Can't initiate a conversation on context of type " + context._0);
      
    }
    onStartedInitiatingConversation$1();
    initiatePropertyConversationMutate({
          connections: connections,
          input: {
            files: files.map(Conversation__ConversationsSection__Common.attachmentToInput),
            images: images.map(Conversation__ConversationsSection__Common.attachmentToInput),
            propertyId: context.id,
            text: state.text
          }
        }, undefined, undefined, undefined, (function (response, errors) {
            var match = response.initiatePropertyConversation;
            if (match === undefined) {
              return notifyOnFailure();
            }
            if (match.__typename !== "PropertyConversationInitiated") {
              return notifyOnFailure();
            }
            var match$1 = match.conversation;
            if (match$1 !== undefined) {
              reset();
              notifyOnSuccess(undefined);
              return onConversationInitiated$1(match$1.id);
            } else {
              return notifyOnFailure();
            }
          }), undefined, undefined);
  };
  var match$6 = ConversationMessageInputForm.useWithAttachments(mutate, (function (files) {
          setUnsupportedFiles(function (param) {
                return files;
              });
        }));
  var form = match$6[0];
  var submitDisabled = form.submitting || !form.valid();
  var tmp;
  switch (context.__typename) {
    case "MessageBroadcast" :
        tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(Conversation__ConversationsSection__SendMessageButtons.SendPrivateMessageButton.make, {
                      submitDisabled: submitDisabled,
                      onSubmit: (function () {
                          messageConversationType.current = "PRIVATE";
                          form.submit();
                        })
                    }),
                JsxRuntime.jsx(Conversation__ConversationsSection__SendMessageButtons.SendPublicMessageButton.make, {
                      submitDisabled: submitDisabled,
                      onSubmit: (function () {
                          messageConversationType.current = "PUBLIC";
                          form.submit();
                        })
                    })
              ]
            });
        break;
    case "__unselected" :
        tmp = null;
        break;
    default:
      tmp = JsxRuntime.jsx(Conversation__ConversationsSection__SendMessageButtons.SendPrivateMessageButton.make, {
            submitDisabled: submitDisabled,
            onSubmit: (function () {
                form.submit();
              })
          });
  }
  var match$7 = form.status;
  var tmp$1;
  tmp$1 = typeof match$7 !== "object" || match$7.TAG !== "SubmissionFailed" ? null : JsxRuntime.jsx(ErrorComponent.make, {
          message: "An error ocurred while sending the message"
        });
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(UnsupportedAttachmentsDialog.make, {
                      files: match[0],
                      onDismiss: (function () {
                          setUnsupportedFiles(function (param) {
                                return [];
                              });
                        })
                    }),
                JsxRuntime.jsx("form", {
                      children: JsxRuntime.jsxs(ViewStack.make, {
                            alignItems: "flexEnd",
                            flexDirection: "column",
                            children: [
                              JsxRuntime.jsx(Conversation__ConversationsSection__ConversationMessageArea.make, {
                                    form: form,
                                    attachmentsManager: match$6[1],
                                    inputRef: props.inputRef,
                                    submitButtons: tmp,
                                    placeholder: agentName !== undefined ? "Message to " + agentName : ""
                                  }),
                              tmp$1
                            ]
                          }),
                      className: "w-full"
                    })
              ]
            });
}

var Commons;

var ConversationMessageForm;

var ConversationMessageArea;

var SendMessageButtons;

var make = Conversation__ConversationsSection__StartFirstConversation;

exports.Fragment = Fragment;
exports.Commons = Commons;
exports.ConversationMessageForm = ConversationMessageForm;
exports.ConversationMessageArea = ConversationMessageArea;
exports.SendMessageButtons = SendMessageButtons;
exports.make = make;
/* react Not a pure module */
